import { IMAGE_SIZE } from 'constants/index';

export const getQueryParams = (queryParamsObj: {
  [index: string]: string;
}): string => {
  const queryParams: string[] = [];
  Object.keys(queryParamsObj).forEach((key, value) => {
    queryParams.push(`${key}=${value}`);
  });
  return queryParams.join('&');
};

/**
 * If the text is an element or text, this helps to convert it into text only
 * innerText returns visible text, textContent return all text
 * textContent is more preferred
 *
 * @param text -  can be a plain text(Hello)or an element("<p>hello</p>")
 * @param isHiddenTextIncluded
 * @returns
 */
export const getTextOnly = (
  text: string,
  isHiddenTextIncluded = true,
): string => {
  const hangingNode = document.createElement('div');
  hangingNode.innerHTML = text;
  return (
    (isHiddenTextIncluded ? hangingNode.textContent : hangingNode.innerText) ||
    ''
  );
};

export const getTextOnlyCount = (
  text: string,
  isHiddenTextIncluded: boolean,
): number => {
  const textOnly = getTextOnly(text, isHiddenTextIncluded);
  return textOnly.length;
};

/**
 * When user has set an image and has made it accessible then the url is of the format
 * https://avatar-management--avatars.us-west-2.staging.public.atl-paas.net/639985aff3c3dfd71fe85b54/78dc580d-14f5-4079-bd82-4e57c441ba41/128
 * where last digits are the size of the image
 *
 * When user has not set an image then the url is of the format
 * https://i2.wp.com/avatar-management--avatars.us-west-2.staging.public.atl-paas.net/initials/VM-1.png?ssl=1
 *
 *
 * @param url
 * @param size
 * @returns
 */
export const getHighResolutionAvatar = (
  url: string,
  size: IMAGE_SIZE,
  defaultAvatar?: string,
): string => {
  // TODO: Importing regex from constants is not working.
  // even on browser the same browser shows answer as true & false alternatively.
  if (!url || !/^(https?|ftp):\/\/[^\s/$.?#].[^\s]*$/gim.test(url)) {
    throw new Error(`Invalid URL: ${url}`);
  }

  const urlObj = new URL(url);
  if (
    urlObj.hostname?.startsWith('avatar-management--avatars') &&
    !urlObj.href.includes('initials')
  ) {
    const urlPathParts = urlObj.pathname.split('/');
    if (!urlPathParts.length) {
      return url;
    }
    urlPathParts[urlPathParts.length - 1] = size.toString();
    urlObj.pathname = urlPathParts.join('/');
    return urlObj.href;
  }

  // if a profile pic is returning an initials avatar url, its hostname could be
  // one among these hostnames: ['secure.gravatar.com', 'i2.wp.com'];
  return defaultAvatar || url;
};
